<template>
  <div>
    <modal :title="title + $t('route.exportTask')" :close-on-click-modal="false"
       :visible.sync="isShowDialog" width="1000px" @close="resetForm">
       <div class="uk-flex">
         <!-- 左侧树形 -->
          <div class="treeClass">

             <StatisticObject
              ref="tree"
               v-if="treeData.length"
              :loadNow="true"
              :tree-data="treeData"
              hide-button
              class="ex-tree"

            ></StatisticObject>

          </div>
          <el-form ref="form" :model="dioForm" :rules="rules" label-width="180px">

          <!-- 右侧表单 -->
          <el-form-item prop="taskName" :label="$t('public.taskName')">
              <el-input v-model.trim="dioForm.taskName" style="width: 250px" maxlength="200"/>
          </el-form-item>
          <el-form-item  :label="$t('public.data')">
            <el-select v-model='data_web' multiple style='width: 250px'
                     :placeholder="$t('integration.please_select')">
            <el-option v-for='item in dataOptions' :key='item.value' :label='item.label' :value='item.value'
              :disabled="item.disabled">
            </el-option>
          </el-select>

          </el-form-item>
          <el-form-item :label="$t('public.demonstrations')" prop='show_type_web'>
            <el-select v-model='show_type_web' style='width: 250px'
               :placeholder="$t('integration.please_select')">
              <el-option v-for='item in fileArray' :key='item.code' :label='item.content' :value='item.code'>
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 数据时长 -->
          <el-form-item :label="$t('public.dataDuration')" prop="durationNum">
          <el-input v-model.number="dioForm.durationNum" style="width:140px;"
            oninput="value=value.replace(/[^\d.]/g, '')" />
          <el-select v-model="dioForm.durationUnit"
            style="margin-left: 10px; width: 100px"
          >
            <el-option :label="item.label" :value="parseInt(item.value)" :key="key"
                v-for="(item, key) in dateUnits"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('public.file_from')" prop="genType">
          <el-radio-group v-model="dioForm.genType">
            <el-radio :label="1">{{ $t('integration.each_week')}}</el-radio>
            <el-radio :label="2">{{ $t('integration.each_month')}}</el-radio>
            <el-radio :label="3">{{ $t('integration.each_year')}}</el-radio>
          </el-radio-group>
          <!-- 每周 -->
          <div class="uk-flex">

          <div v-if="dioForm.genType === 1">
            <el-select
              style="width:150px"
              v-model="dioForm.time.day"
            >
              <el-option
                v-for="item in weekArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <!-- 每月 -->
          <div v-else-if="dioForm.genType === 2">
            <el-select
              style="width:150px"
              v-model="dioForm.time.day"
            >
              <el-option
                v-for="item in dayArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <!-- 每年 -->
          <div v-else>
             <!-- <el-date-picker
              v-model="dioForm.time.month"
              type="month"
              style="width: 150px;">
            </el-date-picker> -->
            <el-select
              style="width:100px"
              v-model="dioForm.time.month"
              @change="changeMonth"
            >
              <el-option
                v-for="item in monthArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>

            <!-- <el-date-picker
              v-model="dioForm.time.day"
              type="date"
              style="width: 150px;"
              class="ml-5">
            </el-date-picker> -->
            <el-select
              style="width:100px"
              class="ml-5"
              v-model="dioForm.time.day"
            >
              <el-option
                v-for="item in dayArr2"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>

          </div>
            <el-time-picker
                v-model="dioForm.time.time"
                style="width: 100px;"
                class="ml-5"
                format="HH:mm"
                value-format="HH:mm"
              >
              </el-time-picker>
          </div>
        </el-form-item>
        <!-- 文件类型 -->
        <el-form-item :label="$t('integration.file_type')" prop="fileType">
          <el-select
            style="width:250px"
            v-model="dioForm.fileType"
          >
            <el-option
              v-for="item in fileTypeArray"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        </el-form>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="isShowDialog = false">{{ $t('public.btn_close') }}</el-button>
        <el-button type="primary" @click="handleSave">{{ $t('public.btn_confirm') }}</el-button>
      </div>
    </modal>


  </div>
</template>
<script>
import { dataType , dateUnits } from '@/utils/convert'
import { addExportTask} from '@/api/modules/export.js'
import { shareParam } from '@/api/modules/public.js'
import StatisticObject from '@/pages/count/statistic/component/StatisticObject/StatisticObject.vue'
import { shareTree } from '@/api/modules/public'


export default {
  name: 'AddDialog',
  components: { StatisticObject },
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'add'
    },
    taskId: {
      type: String | Number,
      default: () => {}
    }
  },
  data(){
    return {
      dioForm: {
        taskName: null,
        data: null,
        showType: '11',
        fileType: null,
        durationNum: null,
        durationUnit: 2,
        genType: 1,
        time: {
          month: null,
          day: null, //日/周几
          time: "01:00" //时间
        },
        carrierList: []

      },
      time: {
        month: null,
        day: null, //日/周几
        time: "01:00" //时间
      },
      // 因为参数格式和前端界面显示的格式不一样，增加一个字段方便写代码
      show_type_web: '1',
      data_web: [],
      options: [],
      fileArray: [],
      fileTypeArray: [],
      dataType,
      dateUnits,
      treeData: [],

      rules: {
        taskName: [
          { required: true, message: this.$t('public.verification_task') + this.$t('integration.cannot_be_empty'), trigger: 'blur' }
        ],
        task_object: [
          { required: true, message: this.$t('public.verify_object') + this.$t('integration.cannot_be_empty'), trigger: 'blur' },
        ],
        duration: [
          { required: true, message: this.$t('public.verify_time') + this.$t('integration.cannot_be_empty'), trigger: 'blur' },
        ],

      },
      dayArr2: []
    }
  },
  computed: {
    isShowDialog: {
      get: function () {
        return this.isShow
      },
      set: function (val) {
        this.$emit('update:isShow', val) // 可以优化成model  或者minx
      }
    },
    title() {
      return this.type === 'add' ? this.$t('integration.add') : this.$t('integration.edit')
    },
    dataTree() {
      return this.$store.getters.SchemaTree.filter(item => {
          return item.sceneCode !== 'all_node';
      });
    },
    // 数据下拉选择框
    dataOptions(){
      return [
        {
          value: 1,
          label: this.$t('public.temp')
        },
        {
          value: 2,
          label: this.$t('public.hum')
        },
        {
          value: 3,
          label: this.$t('public.effective_anomaly'),
          disabled: this.data_web.findIndex(_ => _ === 4) === -1 ? false : true
        },
        {
          value: 4,
          label: this.$t('public.all_anomaly'),
          disabled: this.data_web.findIndex(_ => _ === 3) === -1 ? false : true
        },
        {
          value: 5,
          label: this.$t('gasType.0x00')
        },
        {
          value: 6,
          label: this.$t('gasType.0x01')
        },
        {
          value: 7,
          label: this.$t('gasType.0x04')
        },
        {
          value: 8,
          label: this.$t('gasType.0x0A')
        },
        {
          value: 9,
          label: this.$t('gasType.0x32')
        },
        {
          value: 10,
          label: this.$t('equiType.magnetism')
        },
      ]
    },
    weekArr(){
      return [
        {
          value: 1,
          label: this.$t('week.Monday')
        },
        {
          value: 2,
          label: this.$t('week.Tuesday')
        },
        {
          value: 3,
          label: this.$t('week.Wednesday')
        },
        {
          value: 4,
          label: this.$t('week.Thursday')
        },
        {
          value: 5,
          label: this.$t('week.Friday')
        },
        {
          value: 6,
          label: this.$t('week.Saturday')
        },
        {
          value: 7,
          label: this.$t('week.Sunday')
        },
      ]
    },
    dayArr(){
      let arr = []
      for(let i=1; i<=31; i++){
        arr.push({
          value: i,
          label: i + this.$t('public.sun')
        })
      }
      arr.push({
        value: 0,
        label: this.$t('integration.last_day')
      })
      return arr
    },
    monthArr(){
      let arr = []
      for(let i=1; i<=12; i++){
        arr.push({
          value: i,
          label: i + this.$t('integration.month')
        })
      }
      return arr
    },
  },
  watch: {
    isShowDialog(){
      if(this.isShowDialog && this.type === 'edit'){
        this.getTask()
      }
      if(this.isShowDialog){
        this.getAlaTypes()
        console.log('dataTree===', this.dataTree)
      }
    }
  },
  mounted() {
      this.getAlaTypes()
      this.getTree()
  },

  methods: {
    // 获取数据类型和展示方式
    getAlaTypes () {
      ['probe_data_type', 'export_file_type', 'export_type'].forEach(code => {
        shareParam({
          code,
          type: 0
        }).then(({ result }) => {
          if (code === 'probe_data_type') {
            this.options = result.filter(item => {
              if (item.content === 'temp' || item.content === 'hum') {
                return true
              } else {
                return false
              }
            })
            this.options = this.options.map(item => ({
              code: item.code,
              content: this.$t('sensor.' + item.content),
              name: item.content
            }))
          } else if(code === 'export_file_type'){
            this.fileArray = result.map(item => ({
              code: item.code,
              content: this.$t('analysis.' + item.content)
            }))
          }else{
            const seen = {}
            this.fileTypeArray = result.filter(item => {
              if (seen[item.name]) return false
              seen[item.name] = true
              return true
            }).map(item => ({
              value: parseInt(item.code),
              label: item.name
            }))
          }
        })
      })
    },
    async justify() {
      try {
        return await this.$refs['form'].validate()
      }
      catch (error) {
        return false
      }
    },
    // 保存新增验证任务
    async handleSave() {

      console.log('参数=======', this.dioForm)

      let flag = await this.justify();
      if (!flag) return
      // 整理数据
      if(this.show_type_web === '0'){
        this.dioForm.showType = '10'
      }else if(this.show_type_web === '1'){
        this.dioForm.showType = '11'
      }else{
        this.dioForm.showType = '01'
      }

      let arr = ['0','0','0','0','0','0','0','0','0','0']
      this.data_web.forEach(item => {
        arr[item - 1] = '1'
      })
      this.dioForm.data = arr.join('')


      // 获取树形安装点选中的list
     let ids =  this.$refs.tree.getTreeConfirm()
     console.log('ids=', ids)
      this.dioForm.carrierList = []
      ids.forEach(id => {
        this.dioForm.carrierList.push({
          carrierId: id
        })
      })

      let req = null
      if(this.type === 'add'){
        req = addExportTask(this.dioForm)
      }else{
        // req = updateTask({ ...params, id: this.taskId})
      }

      req.then(({ state }) => {
        if (state.code === 200) {
          this.$message.success($t('integration.success'))
          this.isShowDialog = false
          this.$parent.getList()
          this.resetForm()
        }
      })
    },
    resetForm(){
      this.dioForm = {
        taskName: null,
        data: null,
        showType: '11',
        fileType: null,
        durationNum: null,
        durationUnit: 2,
        genType: 1,
        time: {
          month: null,
          day: null, //日/周几
          time: "01:00" //时间
        },
        carrierList: []

      }
      this.show_type_web = '1'
      this.data_web =  []
    },
    getTree () {
      shareTree({
        isEdit: 0,
        carrier: true,
        all: true
      }).then(({ result }) => {
        this.treeData = (result && result.item) || []
      })
    },
    // 选择年后，后面的月份要跟着变化
    changeMonth(){
      let month = this.dioForm.time.month
      this.dioForm.time.day = ''
      let count = 31
      switch(month){
        case 4:
        case 6:
        case 9:
        case 11:
          count = 30
          break
        case 2:
          count = 28
          break
      }
      let arr = []
      for(let i=1; i<=count; i++){
        arr.push({
          value: i,
          label: i + this.$t('public.sun')
        })
      }
      this.dayArr2 = arr
    }

  }
}
</script>
<style lang="scss" scoped>
.card-swiper {
  width: 150px;
  margin-right: 10px;
  margin-bottom: 10px;
  .title {
    background-color: $theme-color;
  }
}
.del-icon {
  color: red;
  position: absolute;
  right: 20px;
  bottom: 8px;
}
.treeClass {
  width: 300px;
  height: 500px;
  overflow: auto;
  margin-right: 30px;

  .el-tree {
    height: 100%;
  }
}
.ex-tree {
  height: 400px;
  ::v-deep .tree {
    height: 100%;
  }
}

</style>
